import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Typography, Form, Button, Alert } from 'components/base';

import authApi from '../api/auth';

const SignInWithEmailModal = props => {
  const [message, setMessage] = useState();

  const passwordInputRef = useRef();

  const handleOnSignInClick = e => {
    e.preventDefault();

    setMessage();

    const password = passwordInputRef.current.value;

    props.onSubmit({ email: props.email, password });
  };

  const handleOnForgotPasswordClick = async e => {
    e.preventDefault();

    setMessage();

    const { error } = await authApi().resetPassword(props.email);
    if (error) {
      setMessage({ text: 'Oops, something went wrong. Please try again.', type: 'danger' });
    } else {
      setMessage({
        text: `A link to reset your password has been sent to your email address ${props.email}.`,
        type: 'success',
      });
    }
  };

  return (
    <>
      <Typography.P>
        You probably have already an account with your email <strong>{props.email}</strong>. Please
        type your password for the account.
      </Typography.P>
      <Form>
        <Form.Group>
          <Form.Input ref={passwordInputRef} type="password" placeholder="Your password" />
        </Form.Group>
        <Form.Group>
          <Button type="primary" htmlType="submit" block onClick={handleOnSignInClick}>
            Login
          </Button>
        </Form.Group>
        {message && (
          <Form.Group>
            <Alert type={message.type}>{message.text}</Alert>
          </Form.Group>
        )}
        <Form.Group className="mb-0">
          <div className="text-center">
            <Button type="link" onClick={handleOnForgotPasswordClick}>
              Forgot your password?
            </Button>
          </div>
        </Form.Group>
      </Form>
    </>
  );
};

SignInWithEmailModal.propTypes = {
  email: PropTypes.string.isRequired,
  onSubmit: PropTypes.func,
  close: PropTypes.func,
};

export default SignInWithEmailModal;
